import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
    Form,
    Modal,
    ModalBody,
    Input,
    FormGroup,
    ModalHeader,
    Button,
    Label,
    FormFeedback,
    Row,
    Col,
} from "reactstrap"
import * as Yup from "yup"

import { useFormik } from "formik"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import breadcrumbs from "common/Breadcrumbs"
import TaskTitleTable from "./TaskTitleTable"
import { Title } from "chart.js"
import DeleteModel from "common/deleteModel/deleteModel"
import ErrorModel from "common/errorModel/errorModel"
import { exportDataExcel } from "components/Common/ExportData"
import { GetObjByTaskTitleTypes, TaskTitleTypes } from "_mock/Static_data"

function TaskTitleList() {
    document.title = `Task Titles | Raja Rani Couture`
    let { pathname } = useLocation()
    const { deleteApi, getApi, postApi, putApi } = useApi()

    const navigate = useNavigate()

    // useStates
    const [modal, setModal] = useState(false)
    const [tableData, setTableData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [totalRecords, setTotalRecords] = useState(0)
    const [displayStart, setDisplayStart] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [taskTypeValue, setTaskTypeValue] = useState(1)
    const [isError, setIsError] = useState(false)
    const [isMobile, setisMobile] = useState(window.innerWidth < 768)
    const [isEdit, setIsEdit] = useState(false)
    const [taskTitleId, setTaskTitleId] = useState(0)
    // filter data for task-title
    const filterData = textFilter => {
        setSearchText(textFilter == undefined ? '' : textFilter)
    }

    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    // task-title list api
    const taskTitleListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("Task/title/list", '').then(({ data, status }) => {
            if (status === 200) {
                setTableData(data)
                setTotalRecords(data?.length)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    // task-title list api useEffect
    useEffect(() => {
        taskTitleListApi()
    }, [])


    // Create task-title handler
    const handleTaskTitleClick = () => {
        setTaskTypeValue(1)
        toggle()
    }

    // Colors Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            Title: "",
        },
        validationSchema: Yup.object({
            Title: Yup.string().required("The task title is required"),
        }),
        onSubmit: values => {
            if (taskTypeValue == 0) {
                setIsError(true)
                setIsError(true)
                return true
            } else {
                setIsError(false)
                setformSumitLoading(true)
                if (values) {
                    isEdit ?
                        putApi(`Task/title/update`, {
                            Id: taskTitleId,
                            Title: values.Title,
                            TaskTitleType: parseInt(taskTypeValue)
                        }).then(({ data, status }) => {
                            setformSumitLoading(false)
                            if (status == 400) {
                                toast.error(data, {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                toast.success("Sucessfully created", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                                toggle()
                                taskTitleListApi()
                                validation.handleReset()
                            }
                        })
                        :

                        postApi(`Task/title/create`, {
                            Title: values.Title,
                            TaskTitleType: parseInt(taskTypeValue)
                        }).then(({ data, status }) => {
                            setformSumitLoading(false)
                            if (status == 400) {
                                toast.error(data, {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                toast.success("Sucessfully created", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                                toggle()
                                taskTitleListApi()
                                validation.handleReset()
                            }
                        })
                }
            }
        },
    })

    // popup box handler
    const toggle = () => {
        setModal(!modal)
        validation.handleReset()
    }

    const handleDelete = (Id) => {
        setScreenLoad(true)
        if (Id) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this task title permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`Task/title/delete?id=${Id}`).then(
                        ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = tableData
                                    .map(obj => (obj.Id !== Id ? obj : null))
                                    .filter(Boolean)
                                setTableData(updatedArray)
                                toast.success("Task title deleted successfully", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Task Title",
                                    text: data,
                                })
                            }
                            setScreenLoad(false)
                        }
                    )
                } else {
                    setScreenLoad(false)
                }
            })
        }

    }

    const handleEdit = (data) => {
        setIsEdit(true)
        toggle()
        validation.setFieldValue("Title", data?.Title)
        setTaskTypeValue(parseInt(data?.Type))
        setTaskTitleId(data?.Id)
    }

    // table headers & accessor
    const columns = useMemo(
        () => [
            {
                Header: "Task Title",
                accessor: "Title",
            },
            {
                Header: "Task Title Type",
                accessor: "Type",
                width: "12%",
                Cell: ({ row }) => {
                    return <>
                        <div
                            className="textWrap"
                            style={{
                                height: "8px",
                                textAlign: "center",
                                justifyContent: "center",
                            }}
                        >
                            {GetObjByTaskTitleTypes(parseInt(row.original.Type))[0]?.Key}
                        </div>
                    </>
                },
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "8%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            <li className="mytooltip">
                                <i
                                    className=" fs-6 fas fa-edit btn-edit"
                                    id={`edittooltip${row.original.Id}`}
                                    onClick={() => handleEdit(row.original)}
                                ></i>
                                <span className="mytext">Edit</span>
                            </li>

                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-trash-alt btn-delete"
                                    id={`deletetooltip${row.original.Id}`}
                                    onClick={() => handleDelete(row.original.Id)}
                                ></i>
                                <span className="mytext">Delete</span>
                            </li>
                        </ul>
                    )
                },
            },
        ],
        [tableData]
    )

    function writeDataToExcel() {
        setIsLoading(true)
        let header = ["Task Title", "Task Title Type"];
        const mainTitle = "Task Titles";
        const widthObj = [{
            Key: "A",
            Value: 35,
        },
        {
            Key: "B",
            Value: 20,
        },
        ]
        const extention = "Task_Titles.xlsx"
        let excelSheetData = []
        for (let index = 0; index < tableData.length; index++) {
            let dataObj = {
                TaskTitle: tableData[index].Title,
                TaskTitleType: GetObjByTaskTitleTypes(parseInt(tableData[index].Type))[0].Key,
            }
            excelSheetData.push(dataObj)
        }
        var fields = Object.keys(excelSheetData[0]);
        var sheetData = excelSheetData.map(function (row) {
            return fields.map(function (fieldName) {
                return row[fieldName];
            });
        });
        setIsLoading(false)
        sheetData.unshift(header);
        exportDataExcel(sheetData, mainTitle, widthObj, extention)
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />
                <Card>
                    <CardBody>
                        <TaskTitleTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            isAddTaskTitleList={true}
                            handleTaskTitleClick={handleTaskTitleClick}
                            customPageSize={10}
                            className="custom-header-css"
                            filterData={filterData}
                            isLoading={isLoading}
                            TotalRecords={totalRecords}
                            pagePerSize={pagePerSize}
                            writeDataToExcel={writeDataToExcel}
                        />

                        <Modal
                            isOpen={modal}
                            toggle={toggle}
                            centered={true}
                            size="small"
                            style={{ width: !isMobile ? "400px" : "" }}
                        >
                            <div className="modal-content">
                                <ModalHeader toggle={toggle} tag="h5">
                                    {isEdit ? "Update Task Title" : "Create Task Title"}
                                </ModalHeader>
                                <ModalBody>
                                    <Form
                                        onSubmit={e => {
                                            e.preventDefault()
                                            validation.handleSubmit()
                                            return false
                                        }}
                                        onReset={e => {
                                            e.preventDefault
                                            validation.handleReset()
                                            return false
                                        }}
                                    >
                                        <Row>
                                            <FormGroup className="mb-2">
                                                <Label htmlFor="validationCustom03" className="required">
                                                    Ttile
                                                </Label>
                                                <Input
                                                    name="Title"
                                                    placeholder="Enter Task Title"
                                                    type="text"
                                                    className="form-control-sm"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.Title}
                                                    invalid={
                                                        validation.touched.Title && validation.errors.Title
                                                            ? true
                                                            : false
                                                    }
                                                />
                                                {validation.touched.Title && validation.errors.Title ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.Title}
                                                    </FormFeedback>
                                                ) : null}
                                            </FormGroup>
                                        </Row>
                                        <Row>
                                            <FormGroup className="mb-2">
                                                <Label
                                                    htmlFor="validationCustom03"
                                                    className="required"
                                                >
                                                    Task Title Type
                                                </Label>
                                                <Input
                                                    type="select"
                                                    bsSize="sm"
                                                    id="validationCustom01"
                                                    className="form-control-sm"
                                                    name="taskType"
                                                    onChange={e => {
                                                        setTaskTypeValue(e.target.value)
                                                        setIsError(false)
                                                    }}
                                                    onBlur={validation.handleBlur}
                                                    value={taskTypeValue}
                                                    invalid={isError}
                                                >
                                                    {TaskTitleTypes.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.Value}>{item.Key}</option>
                                                        )
                                                    })}
                                                    {/* <option value={2}>Lead</option>
                                                    <option value={3}>Parcel</option>
                                                    <option value={4}>Appointment</option>
                                                    <option value={5}>Making</option> */}
                                                </Input>
                                                {isError ? (
                                                    <div className="name-required">
                                                        {" Task Title Type Required"}
                                                    </div>
                                                ) : null}
                                            </FormGroup>
                                        </Row>
                                        <div className="text-end">
                                            <Button
                                                task-title="secondary"
                                                className="btn btn-primary me-2 btn-sm "
                                                type="reset"
                                                color="secondary"
                                            >
                                                Reset
                                            </Button>
                                            {formSumitLoading ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                >
                                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                    Loading
                                                </button>
                                            ) : (
                                                <Button
                                                    color="primary"
                                                    task-title="primary"
                                                    className="btn btn-primary btn-sm "
                                                    type="submit"
                                                >
                                                    Submit
                                                </Button>
                                            )}
                                        </div>
                                    </Form>
                                </ModalBody>
                            </div>
                        </Modal>
                    </CardBody>
                </Card>
            </div>
        </div>
    )
}
TaskTitleList.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default TaskTitleList
